export var SalesforceActions = /*#__PURE__*/ function(SalesforceActions) {
    SalesforceActions["Project"] = "project";
    SalesforceActions["Task"] = "task";
    return SalesforceActions;
}({});
export var SalesforceActionsV2 = /*#__PURE__*/ function(SalesforceActionsV2) {
    SalesforceActionsV2["Project"] = "scarletProject";
    SalesforceActionsV2["Task"] = "task";
    SalesforceActionsV2["Account"] = "company";
    SalesforceActionsV2["Contact"] = "user";
    return SalesforceActionsV2;
}({});
export var AutomationOperation = /*#__PURE__*/ function(AutomationOperation) {
    AutomationOperation["Upsert"] = "UPSERT";
    AutomationOperation["UpsertRelatedRecords"] = "UPSERT_RELATED_RECORDS";
    return AutomationOperation;
}({});
export var IntegrationSource = /*#__PURE__*/ function(IntegrationSource) {
    IntegrationSource["NativeIntegration"] = "NATIVE_INTEGRATION";
    return IntegrationSource;
}({});
export var SalesforceSyncTypes = /*#__PURE__*/ function(SalesforceSyncTypes) {
    SalesforceSyncTypes["SyncTwoWay"] = "SYNC_TWO_WAY";
    SalesforceSyncTypes["SyncNativeToExternal"] = "SYNC_NATIVE_TO_EXTERNAL";
    SalesforceSyncTypes["SyncExternalToNative"] = "SYNC_EXTERNAL_TO_NATIVE";
    SalesforceSyncTypes["None"] = "NONE";
    return SalesforceSyncTypes;
}({});
// TODO: @krishna Remove this once the error codes are standardised
export var AutomationErrorCodes = /*#__PURE__*/ function(AutomationErrorCodes) {
    AutomationErrorCodes["ConflictingFieldValue"] = "CONFLICTING_FIELD_VALUE";
    return AutomationErrorCodes;
}({});
